import { formatUserFacingError } from '@/lib/errors'
import { useEffect, useState } from 'react'
import { seasonsService } from '../services/seasons.service'
import type { FilmDocument } from '@/types'

interface UseProjectsResult {
  projects: Array<FilmDocument & { id: string }>
  loading: boolean
  error: string | null
}

export function useProjects(): UseProjectsResult {
  const [projects, setProjects] = useState<Array<FilmDocument & { id: string }>>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setLoading(true)
    setError(null)
    seasonsService
      .getProjects()
      .then(setProjects)
      .catch((err: unknown) => setError(formatUserFacingError(err, 'Failed to load projects')))
      .finally(() => setLoading(false))
  }, [])

  return { projects, loading, error }
}
